"use client";

import { useState } from "react";
import { RegionMap } from "@/components/region-map";

export default function TestRegionMapPage() {
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);

  const handleRegionSelect = (regionId: string) => {
    setSelectedRegion(regionId);
    console.log("Selected region:", regionId);
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-foreground">
            강원도 지역 지도 컴포넌트 테스트
          </h1>
          <p className="text-muted-foreground">
            지도에서 지역을 클릭하거나 키보드로 선택해보세요.
          </p>
        </div>

        <div className="space-y-4">
          <RegionMap 
            onSelect={handleRegionSelect}
            className="max-w-2xl mx-auto"
          />
          
          {selectedRegion && (
            <div className="text-center p-4 bg-muted rounded-lg">
              <p className="text-sm text-muted-foreground">현재 선택된 지역:</p>
              <p className="text-lg font-semibold text-primary">{selectedRegion}</p>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">컴포넌트 기능</h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• 마우스 클릭으로 지역 선택</li>
            <li>• 키보드 탭으로 포커스 이동 후 Enter/Space로 선택</li>
            <li>• 호버 시 툴팁으로 지역명 표시</li>
            <li>• URL 쿼리 파라미터와 동기화 (?region=지역id)</li>
            <li>• 접근성을 위한 ARIA 라벨 및 포커스 관리</li>
            <li>• 반응형 디자인 지원</li>
          </ul>
        </div>
      </div>
    </div>
  );
}